module.exports = __webpack_public_path__ + "img/red-hoodie.38f7c8db.jpg";